// ═══════════════════════════════════════════════════════════════════════
// BELLANOR ALTA PERFORMANCE — dados base do sistema
// ═══════════════════════════════════════════════════════════════════════

// ─── Módulos disponíveis (para sistema de permissões) ────────────────
export const MODULES = [
  { id: "dashboard",    label: "Dashboard" },
  { id: "vendas",       label: "Vendas" },
  { id: "propostas",    label: "Propostas" },
  { id: "financeiro",   label: "Pagamentos" },
  { id: "ranking",      label: "Ranking" },
  { id: "corretores",   label: "Corretores" },
  { id: "times",        label: "Times" },
  { id: "regional",     label: "Regional" },
  { id: "nacional",     label: "Nacional" },
  { id: "rede",         label: "Rede" },
  { id: "clientes",     label: "CRM" },
  { id: "plantao",      label: "Plantão" },
  { id: "meusettings",  label: "Configurações Corretor" },
  { id: "config",       label: "Configurações App" },
];

// ─── Origem do lead (metrificar de onde vem) ─────────────────────────
export const ORIGENS_LEAD = [
  { id: "meta",       label: "Meta (Facebook/Instagram)" },
  { id: "google",     label: "Google" },
  { id: "prospeccao", label: "Prospecção Ativa" },
  { id: "indicacao",  label: "Indicação" },
  { id: "manual",     label: "Outro / manual" },
];

// ─── Templates de proposta (goprospero) — edite conforme seus modelos ─
export const TEMPLATES_PROPOSTA = [
  "Projeto Mobiliário",
  "Aura Glow",
  "Sofá / Estofados",
  "Poltronas",
  "Espelho / LED",
  "Cabeceira",
  "Outro",
];

// ─── Awards e regras de pontuação ────────────────────────────────────
// pctVendaDireta = % aplicada sobre o LÍQUIDO (valor - frete - taxas)
// bonusResidual   = +pp somado ao % base de cada nível ao calcular residual
// niveisRede      = quantos níveis de residual o corretor recebe (1..10)
export const AWARDS = [
  {
    id: "cafe",
    nome: "Café com leite",
    pts: 0,
    max: 49,
    pctVendaDireta: 6.0,
    bonusResidual: 0,
    comissaoAdd: 0,
    niveisRede: 1,
    quadro: false,
    cor: "cafe",
    descricao: "Ponto de partida — ainda sem award conquistado.",
  },
  {
    id: "bronze",
    nome: "Bronze Award",
    pts: 50,
    max: 99,
    pctVendaDireta: 6.5,
    bonusResidual: 0.5,
    comissaoAdd: 0.5,
    comissaoEscopo: "venda direta + residual",
    niveisRede: 2,
    quadro: true,
    cor: "bronze",
    descricao: "Primeiro nível de reconhecimento — a jornada começa aqui.",
  },
  {
    id: "silver",
    nome: "Silver Award",
    pts: 100,
    max: 199,
    pctVendaDireta: 7.0,
    bonusResidual: 1.0,
    comissaoAdd: 1.0,
    comissaoEscopo: "venda direta + residual",
    niveisRede: 3,
    quadro: true,
    cor: "silver",
    descricao: "Consistência e dedicação — rede se expandindo.",
  },
  {
    id: "gold",
    nome: "Golden Award",
    pts: 200,
    max: 299,
    pctVendaDireta: 7.5,
    bonusResidual: 1.5,
    comissaoAdd: 1.5,
    comissaoEscopo: "venda direta + residual",
    niveisRede: 5,
    quadro: true,
    cor: "gold",
    descricao: "Destaque da operação — elegível ao iPhone do ano.",
    premio: { nome: "iPhone do ano", volMin: 2_000_000 },
  },
  {
    id: "platinum",
    nome: "Platinum Award",
    pts: 300,
    max: 499,
    pctVendaDireta: 8.0,
    bonusResidual: 2.0,
    comissaoAdd: 2.0,
    comissaoEscopo: "venda direta + residual",
    niveisRede: 7,
    quadro: true,
    cor: "platinum",
    descricao: "Alto desempenho — elegível ao cruzeiro de luxo.",
    premio: { nome: "Cruzeiro de luxo (2 pessoas)", volMin: 3_000_000 },
  },
  {
    id: "diamond",
    nome: "Diamond Award",
    pts: 500,
    max: Infinity,
    pctVendaDireta: 10.0,
    bonusResidual: 2.5,
    comissaoAdd: 2.5,
    comissaoEscopo: "venda direta + residual",
    niveisRede: 10,
    quadro: true,
    cor: "diamond",
    descricao: "Elite Bellanor — elegível ao BYD elétrico e ao programa de franquias.",
    premio: { nome: "Veículo BYD 100% elétrico", volMin: 5_000_000 },
    franquia: true,
  },
];

// ─── Comissão multinível ────────────────────────────────────────────
// pctNivelBase[n] = % residual sobre a COMISSÃO direta para o nível n (n=1..10)
// Total residual aplicado = pctNivelBase[n] + AWARDS[awardRecebedor].bonusResidual
export const COMISSAO_NIVEIS_BASE = [
  null,   // índice 0 não usado
  3.0,    // N1
  2.75,   // N2
  2.5,    // N3
  2.25,   // N4
  2.0,    // N5
  1.75,   // N6
  1.5,    // N7
  1.25,   // N8
  1.0,    // N9
  0.5,    // N10
];

// Default config gravada em Supabase configuracoes.comissoes
export const COMISSAO_CONFIG_DEFAULT = {
  pctVendaDireta: { cafe: 6.0, bronze: 6.5, silver: 7.0, gold: 7.5, platinum: 8.0, diamond: 10.0 },
  bonusResidual:  { cafe: 0,   bronze: 0.5, silver: 1.0, gold: 1.5, platinum: 2.0, diamond: 2.5 },
  pctNivelBase:   [null, 3.0, 2.75, 2.5, 2.25, 2.0, 1.75, 1.5, 1.25, 1.0, 0.5],
  niveisLiberados:{ cafe: 1, bronze: 2, silver: 3, gold: 5, platinum: 7, diamond: 10 },
};

// ─── Metas de expansão de rede (sugestão visual) ─────────────────────
export const METAS_REDE = [
  { award: "bronze",   novos: 5 },
  { award: "silver",   novos: 10 },
  { award: "gold",     novos: 15 },
  { award: "platinum", novos: 20 },
  { award: "diamond",  novos: 30 },
];

// ─── Regras de pontuação ─────────────────────────────────────────────
export const REGRAS_PONTOS = {
  vendaDireta: 1,        // 1 venda paga = 1 ponto
  ativacaoRede: 10,      // 1 corretor N1 que fez 1ª venda paga = 10 pontos
};

// ─── Times ───────────────────────────────────────────────────────────
// Padrão de nomenclatura: [Identidade] de [Cidade/Região]
// Campo `ativo` permite desativar sem apagar histórico
// Campo `emoji` é o "badge" visual do time (admin pode editar)
export const TIMES = [
  { id: "calangos-de-fortal",      nome: "Calangos de Fortal",          cidade: "Fortaleza",       uf: "CE", ativo: true, emoji: "🦎" },
  { id: "capivaras-da-revoada",    nome: "Capivaras da Revoada",        cidade: "Taboão da Serra", uf: "SP", ativo: true, emoji: "🦫" },
  { id: "araras-do-acre",          nome: "Araras do Acre",              cidade: "Rio Branco",      uf: "AC", ativo: true, emoji: "🦜" },
  { id: "botos-do-amazonas",       nome: "Botos do Amazonas",           cidade: "Manaus",          uf: "AM", ativo: true, emoji: "🐬" },
  { id: "gavioes-reais-do-amapa",  nome: "Gaviões-Reais do Amapá",      cidade: "Macapá",          uf: "AP", ativo: true, emoji: "🦅" },
  { id: "guaras-do-para",          nome: "Guarás do Pará",              cidade: "Belém",           uf: "PA", ativo: true, emoji: "🦩" },
  { id: "ariranhas-de-rondonia",   nome: "Ariranhas de Rondônia",       cidade: "Porto Velho",     uf: "RO", ativo: true, emoji: "🦦" },
  { id: "galos-da-serra-de-rorai", nome: "Galos-da-Serra de Roraima",   cidade: "Boa Vista",       uf: "RR", ativo: true, emoji: "🐓" },
  { id: "lobos-guara-do-tocantin", nome: "Lobos-Guará do Tocantins",    cidade: "Palmas",          uf: "TO", ativo: true, emoji: "🐺" },
  { id: "golfinhos-de-alagoas",    nome: "Golfinhos de Alagoas",        cidade: "Maceió",          uf: "AL", ativo: true, emoji: "🐬" },
  { id: "tartarugas-da-bahia",     nome: "Tartarugas da Bahia",         cidade: "Salvador",        uf: "BA", ativo: true, emoji: "🐢" },
  { id: "tucunares-do-maranhao",   nome: "Tucunarés do Maranhão",       cidade: "São Luís",        uf: "MA", ativo: true, emoji: "🐟" },
  { id: "seriemas-da-paraiba",     nome: "Seriemas da Paraíba",         cidade: "João Pessoa",     uf: "PB", ativo: true, emoji: "🦤" },
  { id: "leoes-do-norte",          nome: "Leões do Norte",              cidade: "Recife",          uf: "PE", ativo: true, emoji: "🦁" },
  { id: "araras-azuis-do-piaui",   nome: "Araras-Azuis do Piauí",       cidade: "Teresina",        uf: "PI", ativo: true, emoji: "🦜" },
  { id: "emas-do-rn",              nome: "Emas do RN",                  cidade: "Natal",           uf: "RN", ativo: true, emoji: "🦃" },
  { id: "corujoes-de-sergipe",     nome: "Corujões de Sergipe",         cidade: "Aracaju",         uf: "SE", ativo: true, emoji: "🦉" },
  { id: "micos-dourados-do-rio",   nome: "Micos-Dourados do Rio",       cidade: "Rio de Janeiro",  uf: "RJ", ativo: true, emoji: "🐒" },
];

// Sugestões de emojis populares para times (admin pode escolher livremente)
export const TIME_EMOJI_SUGESTOES = [
  "🐆", "🦁", "🐯", "🐺", "🦅", "🦉", "🦊", "🐉", "🦈", "🐋",
  "⚡", "🔥", "⭐", "💎", "👑", "🏆", "🎯", "🚀", "💪", "🌟",
  "🌵", "🌊", "🏔️", "🌴", "🦜", "🦚", "🐅", "🐃", "🐪", "🦄",
];

// ─── Corretores reais (10) ───────────────────────────────────────────
// Para o mock, dados foram distribuídos respeitando cidade/time indicados.
// Pontuação: mix de vendas diretas e ativações, valores simulados.
export const DEFAULT_CORRETORES = [
  // Cawan já é Golden (222 pts totais vitalícios) e elegível ao iPhone (R$ 2,15M ano)
  // Raquel é a mais próxima de virar Golden (145 pts, faltam 55)
  //
  // Dados novos:
  // - vendasDiretas/vendasValor = TOTAL VITALÍCIO (acumula pra sempre)
  // - vendasValorAno = só do ano corrente (zera em 1/jan, pra prêmios)
  // - vendasValorMes/Semana = mock de ritmo recente pra ranking temporal
  // - pontosSemana/Mes/Ano = pontos feitos só naquele período (pra ranking individual)
  // - semanasComo1Time/Regional/Nacional = contador p/ anti-monopólio
  //
  // === Onças-Pintadas de Fortal (Fortaleza-CE) ===
  { id: 1,  nome: "Cawan Paiva",         foto: null, cidade: "Fortaleza", uf: "CE", timeId: "oncas-fortal",
    vendasDiretas: 142, vendasValor: 2_150_000, vendasValorAno: 2_150_000,
    vendasValorMes: 195_000, vendasValorSemana: 52_000,
    pontosSemana: 8, ativacoesSemana: 1, pontosMes: 24, pontosAno: 222,
    cadastrados: 12, ativados: 8, ativadosInativos90d: 0,
    semanasComo1Time: 0, semanasComo1Regional: 0, semanasComo1Nacional: 0 },

  { id: 2,  nome: "Jessica Cavalcante",  foto: null, cidade: "Fortaleza", uf: "CE", timeId: "oncas-fortal",
    vendasDiretas: 118, vendasValor: 1_780_000, vendasValorAno: 1_780_000,
    vendasValorMes: 168_000, vendasValorSemana: 48_000,
    pontosSemana: 7, ativacoesSemana: 1, pontosMes: 19, pontosAno: 158,
    cadastrados: 6, ativados: 4, ativadosInativos90d: 0,
    semanasComo1Time: 0, semanasComo1Regional: 0, semanasComo1Nacional: 0 },

  { id: 3,  nome: "Raquel Nascimento",   foto: null, cidade: "Fortaleza", uf: "CE", timeId: "oncas-fortal",
    vendasDiretas: 95,  vendasValor: 1_430_000, vendasValorAno: 1_430_000,
    vendasValorMes: 142_000, vendasValorSemana: 38_000,
    pontosSemana: 5, ativacoesSemana: 0, pontosMes: 15, pontosAno: 135,
    cadastrados: 9, ativados: 5, ativadosInativos90d: 1,
    semanasComo1Time: 0, semanasComo1Regional: 0, semanasComo1Nacional: 0 },

  { id: 4,  nome: "Lu Vasconcelos",      foto: null, cidade: "Fortaleza", uf: "CE", timeId: "oncas-fortal",
    vendasDiretas: 76,  vendasValor: 1_120_000, vendasValorAno: 1_120_000,
    vendasValorMes: 98_000, vendasValorSemana: 26_000,
    pontosSemana: 3, ativacoesSemana: 0, pontosMes: 10, pontosAno: 96,
    cadastrados: 4, ativados: 2, ativadosInativos90d: 0,
    semanasComo1Time: 0, semanasComo1Regional: 0, semanasComo1Nacional: 0 },

  { id: 5,  nome: "Thays Souza",         foto: null, cidade: "Fortaleza", uf: "CE", timeId: "oncas-fortal",
    vendasDiretas: 52,  vendasValor: 780_000,   vendasValorAno: 780_000,
    vendasValorMes: 72_000, vendasValorSemana: 18_000,
    pontosSemana: 2, ativacoesSemana: 0, pontosMes: 7, pontosAno: 72,
    cadastrados: 3, ativados: 2, ativadosInativos90d: 0,
    semanasComo1Time: 0, semanasComo1Regional: 0, semanasComo1Nacional: 0 },

  { id: 6,  nome: "Vitória Souza",       foto: null, cidade: "Fortaleza", uf: "CE", timeId: "oncas-fortal",
    vendasDiretas: 38,  vendasValor: 580_000,   vendasValorAno: 580_000,
    vendasValorMes: 55_000, vendasValorSemana: 12_000,
    pontosSemana: 1, ativacoesSemana: 0, pontosMes: 5, pontosAno: 48,
    cadastrados: 2, ativados: 1, ativadosInativos90d: 0,
    semanasComo1Time: 0, semanasComo1Regional: 0, semanasComo1Nacional: 0 },

  // === Revoadas de SP (Taboão da Serra-SP) ===
  { id: 7,  nome: "Cássia Layane",       foto: null, cidade: "Taboão da Serra", uf: "SP", timeId: "revoadas-sp",
    vendasDiretas: 88,  vendasValor: 1_310_000, vendasValorAno: 1_310_000,
    vendasValorMes: 128_000, vendasValorSemana: 34_000,
    pontosSemana: 4, ativacoesSemana: 1, pontosMes: 12, pontosAno: 118,
    cadastrados: 5, ativados: 3, ativadosInativos90d: 0,
    semanasComo1Time: 0, semanasComo1Regional: 0, semanasComo1Nacional: 0 },

  { id: 8,  nome: "Brunas Veras",        foto: null, cidade: "Taboão da Serra", uf: "SP", timeId: "revoadas-sp",
    vendasDiretas: 64,  vendasValor: 950_000,   vendasValorAno: 950_000,
    vendasValorMes: 85_000, vendasValorSemana: 21_000,
    pontosSemana: 2, ativacoesSemana: 0, pontosMes: 8, pontosAno: 84,
    cadastrados: 3, ativados: 2, ativadosInativos90d: 0,
    semanasComo1Time: 0, semanasComo1Regional: 0, semanasComo1Nacional: 0 },

  // === Pioneiros (sem time — abrem mercado em nova praça) ===
  { id: 9,  nome: "Douglas Diniz",       foto: null, cidade: "João Pessoa", uf: "PB", timeId: null,
    vendasDiretas: 71,  vendasValor: 1_050_000, vendasValorAno: 1_050_000,
    vendasValorMes: 95_000, vendasValorSemana: 28_000,
    pontosSemana: 3, ativacoesSemana: 0, pontosMes: 11, pontosAno: 101,
    cadastrados: 4, ativados: 3, ativadosInativos90d: 0,
    semanasComo1Time: 0, semanasComo1Regional: 0, semanasComo1Nacional: 0 },

  { id: 10, nome: "Gleide Selma",        foto: null, cidade: "Aracaju", uf: "SE", timeId: null,
    vendasDiretas: 45,  vendasValor: 680_000,   vendasValorAno: 680_000,
    vendasValorMes: 62_000, vendasValorSemana: 15_000,
    pontosSemana: 2, ativacoesSemana: 0, pontosMes: 6, pontosAno: 55,
    cadastrados: 2, ativados: 1, ativadosInativos90d: 0,
    semanasComo1Time: 0, semanasComo1Regional: 0, semanasComo1Nacional: 0 },
];

// ─── Usuários (login) ────────────────────────────────────────────────
// Cada corretor tem um login vinculado ao seu id.
export const DEFAULT_USERS = [
  // === Proprietário ===
  { id: 0, username: "gilzao", password: "bellanor2026",
    role: "proprietario", nome: "Gil Brito Lucas", corretorId: null,
    modules: MODULES.map(m => m.id) },

  // === Admin ===
  { id: 11, username: "augusto", password: "augusto2026",
    role: "admin", nome: "Augusto Sérgio Mesquita", corretorId: null,
    modules: MODULES.map(m => m.id) },

  // === Corretores ===
  { id: 1, username: "cawan",    password: "cawan2026",    role: "corretor", nome: "Cawan Paiva",        corretorId: 1,
    modules: ["dashboard","ranking","financeiro","times","regional","nacional","clientes","rede","meusettings"] },
  { id: 2, username: "jessica",  password: "jessica2026",  role: "corretor", nome: "Jessica Cavalcante", corretorId: 2,
    modules: ["dashboard","ranking","financeiro","times","regional","nacional","clientes","rede","meusettings"] },
  { id: 3, username: "raquel",   password: "raquel2026",   role: "corretor", nome: "Raquel Nascimento",  corretorId: 3,
    modules: ["dashboard","ranking","financeiro","times","regional","nacional","clientes","rede","meusettings"] },
  { id: 4, username: "lu",       password: "lu2026",       role: "corretor", nome: "Lu Vasconcelos",     corretorId: 4,
    modules: ["dashboard","ranking","financeiro","times","regional","nacional","clientes","rede","meusettings"] },
  { id: 5, username: "thays",    password: "thays2026",    role: "corretor", nome: "Thays Souza",        corretorId: 5,
    modules: ["dashboard","ranking","financeiro","times","regional","nacional","clientes","rede","meusettings"] },
  { id: 6, username: "vitoria",  password: "vitoria2026",  role: "corretor", nome: "Vitória Souza",      corretorId: 6,
    modules: ["dashboard","ranking","financeiro","times","regional","nacional","clientes","rede","meusettings"] },
  { id: 7, username: "cassia",   password: "cassia2026",   role: "corretor", nome: "Cássia Layane",      corretorId: 7,
    modules: ["dashboard","ranking","financeiro","times","regional","nacional","clientes","rede","meusettings"] },
  { id: 8, username: "brunas",   password: "brunas2026",   role: "corretor", nome: "Brunas Veras",       corretorId: 8,
    modules: ["dashboard","ranking","financeiro","times","regional","nacional","clientes","rede","meusettings"] },
  { id: 9, username: "douglas",  password: "douglas2026",  role: "corretor", nome: "Douglas Diniz",      corretorId: 9,
    modules: ["dashboard","ranking","financeiro","times","regional","nacional","clientes","rede","meusettings"] },
  { id: 10,username: "gleide",   password: "gleide2026",   role: "corretor", nome: "Gleide Selma",       corretorId: 10,
    modules: ["dashboard","ranking","financeiro","times","regional","nacional","clientes","rede","meusettings"] },

  // === Operacional (logística + suporte integrados) ===
  { id: 100, username: "logistica", password: "log123",
    role: "operacional", nome: "Encarregado Logística", corretorId: null,
    modules: ["logistica", "suporte", "regulamento"] },
];

// ─── Metas coletivas (Caminho A: Volume + Ativações + Supermeta) ─────
// Cada camada (Time/Regional/Nacional) tem 2 metas independentes:
//   - metaVolume:     volume em R$ no ciclo
//   - metaAtivacoes:  corretores ativados (com vendas nos últimos 90d) no ciclo
//   - SUPERMETA = bater as DUAS metas simultaneamente (premio maior)
export const METAS_DEFAULT = {
  time: {
    ciclo: "semanal",
    metaVolume: 300_000,     // R$ 300k em vendas diretas no time por semana
    metaAtivacoes: 2,        // 2 ativações novas por semana
    premioVolume:    "Vale-cultura R$ 200 por membro (prêmio Volume)",
    premioAtivacoes: "Curso de liderança online por membro (prêmio Ativações)",
    premioSupermeta: "Jantar premium do time inteiro (Supermeta)",
  },
  regional: {
    ciclo: "mensal",
    metaVolume: 3_000_000,   // R$ 3M por regional por mês
    metaAtivacoes: 5,        // 5 ativações novas por mês
    premioVolume:    "Troféu regional do mês em cerimônia no Instagram Bellanor",
    premioAtivacoes: "Curso presencial de vendas consultivas",
    premioSupermeta: "Happy hour completo com a regional inteira",
  },
  nacional: {
    ciclo: "mensal",
    metaVolume: 10_000_000,  // R$ 10M nacional por mês
    metaAtivacoes: 15,       // 15 ativações globais por mês
    premioVolume:    "Bônus em espécie proporcional no holerite",
    premioAtivacoes: "Menção individual no Instagram Bellanor + selo digital",
    premioSupermeta: "Experiência premium (viagem, spa ou equivalente)",
  },
};

// ─── Aceleradores (configuráveis) ────────────────────────────────────
export const ACELERADORES_DEFAULT = {
  timeMeta: 10,
  timeSupermeta: 20,
  regionalMeta: 10,
  regionalSupermeta: 20,
  nacionalMeta: 15,
  nacionalSupermeta: 25,
};

// ─── Metas Individuais por Award (editáveis pelo admin) ──────────────
// Cada corretor, baseado no seu Award Vitalício, tem uma meta SEMANAL
// individual de volume R$ e ativações. Admin edita pelo portal.
// As contribuições individuais já alimentam Time/Regional/Nacional;
// aqui o corretor vê o reflexo pessoal das mesmas vendas e ativações.
//
// Valores padrão são sugestão progressiva. Admin DEVE revisar com base
// no ritmo real dos corretores Bellanor.
export const METAS_INDIVIDUAIS_DEFAULT = {
  cafe:     { nome: "Café com leite", volume:  20_000, ativacoes: 0 },
  bronze:   { nome: "Bronze Award",   volume:  35_000, ativacoes: 1 },
  silver:   { nome: "Silver Award",   volume:  50_000, ativacoes: 1 },
  gold:     { nome: "Golden Award",   volume:  70_000, ativacoes: 2 },
  platinum: { nome: "Platinum Award", volume:  95_000, ativacoes: 3 },
  diamond:  { nome: "Diamond Award",  volume: 130_000, ativacoes: 3 },
};

// ─── Prêmios anuais editáveis ────────────────────────────────────────
export const PREMIOS_DEFAULT = {
  iphone: {
    nome: "iPhone do ano",
    descricao: "iPhone mais recente, na cor à escolha do ganhador.",
    requisito: "Golden Award (200 pts) + R$ 2.000.000 em vendas diretas no ano.",
    ano: new Date().getFullYear(),
  },
  cruzeiro: {
    nome: "Cruzeiro de luxo",
    descricao: "Pacote para 2 pessoas em cruzeiro de luxo, destino definido pela Bellanor.",
    requisito: "Platinum Award (300 pts) + R$ 3.000.000 em vendas diretas no ano.",
    ano: new Date().getFullYear(),
  },
  byd: {
    nome: "Veículo BYD 100% elétrico",
    descricao: "Veículo BYD elétrico, modelo definido pela Bellanor no início do ciclo.",
    requisito: "Diamond Award (500 pts) + R$ 5.000.000 em vendas diretas no ano.",
    ano: new Date().getFullYear(),
  },
};

// ─── Catálogo do Simulador (mantido genérico conforme combinado) ─────
export const CATALOGO = {
  salao: [
    { item: "Poltrona Hidráulica Premium",  area: 1.5, preco: 2800 },
    { item: "Lavatório com Bacia Cerâmica", area: 1.0, preco: 1950 },
    { item: "Bancada com Espelho Camarim",  area: 1.8, preco: 3200 },
    { item: "Cadeira de Espera Lounge",     area: 0.8, preco: 890 },
    { item: "Balcão de Recepção",           area: 2.5, preco: 4500 },
    { item: "Trolley de Ferramentas",       area: 0.4, preco: 650 },
    { item: "Mesa para Manicure",           area: 1.2, preco: 1180 },
  ],
  barbearia: [
    { item: "Cadeira de Barbeiro Vintage",  area: 1.6, preco: 3400 },
    { item: "Espelho Barber Style",         area: 1.0, preco: 890 },
    { item: "Lavatório Reclinável",         area: 1.2, preco: 2300 },
    { item: "Poltrona de Espera Couro",     area: 0.9, preco: 1100 },
    { item: "Balcão Industrial",            area: 2.2, preco: 3800 },
    { item: "Prateleira Expositora",        area: 0.3, preco: 520 },
  ],
  clinica: [
    { item: "Maca Estética Elétrica",       area: 2.4, preco: 4900 },
    { item: "Cadeira de Procedimento",      area: 1.5, preco: 3200 },
    { item: "Armário Clínico Inox",         area: 0.8, preco: 1750 },
    { item: "Mocho Pneumático Premium",     area: 0.4, preco: 780 },
    { item: "Carrinho de Materiais",        area: 0.6, preco: 920 },
    { item: "Recepção Clínica",             area: 2.8, preco: 5400 },
  ],
};

// ─── Seed de CRM (clientes) ──────────────────────────────────────────
export const DEFAULT_CLIENTES = [
  { id: 1, nome: "Studio Bella", segmento: "salao", responsavel: "Beatriz Souza",
    telefone: "(85) 99999-1111", cidade: "Fortaleza, CE",
    ultimaCompra: "2024-10-12", valorHistorico: 18400, wixUrl: "",
    obs: "Pediu orçamento para reforma completa em janeiro." },
  { id: 2, nome: "Barbearia Régio", segmento: "barbearia", responsavel: "Marcos Ribeiro",
    telefone: "(85) 99999-2222", cidade: "Fortaleza, CE",
    ultimaCompra: "2025-03-02", valorHistorico: 9200, wixUrl: "",
    obs: "Expansão planejada para segunda unidade." },
  { id: 3, nome: "Clínica Lumière", segmento: "clinica", responsavel: "Dra. Joana Lins",
    telefone: "(85) 99999-3333", cidade: "Caucaia, CE",
    ultimaCompra: "2023-08-20", valorHistorico: 32800, wixUrl: "",
    obs: "Alta prioridade — dentro da janela de recompra." },
  { id: 4, nome: "Espaço Glam", segmento: "salao", responsavel: "Tatiane Lima",
    telefone: "(85) 99999-4444", cidade: "Fortaleza, CE",
    ultimaCompra: "2025-01-18", valorHistorico: 14500, wixUrl: "",
    obs: "Cliente satisfeita, possível indicação." },
];

// ─── Seed de logística ───────────────────────────────────────────────
export const DEFAULT_PEDIDOS = [
  { id: "#4521", cliente: "Espaço Glam", itens: "Poltrona Recline x2, Bancada Lux x1",
    etapa: 3, previsao: "19 Abr", cidade: "Fortaleza, CE", urgente: true,
    transportadora: "Rodonaves", fotoColeta: null, fotoEntrega: null },
  { id: "#4518", cliente: "Studio Bella", itens: "Lavatório Premium x1",
    etapa: 1, previsao: "22 Abr", cidade: "Fortaleza, CE", urgente: false,
    transportadora: "Freteiro - José", fotoColeta: null, fotoEntrega: null },
  { id: "#4509", cliente: "Beauty House", itens: "Espelho Camarim x3, Trolley x2",
    etapa: 0, previsao: "25 Abr", cidade: "Caucaia, CE", urgente: false,
    transportadora: "", fotoColeta: null, fotoEntrega: null },
  { id: "#4495", cliente: "Nail Art Studio", itens: "Mesa para esmaltação x4",
    etapa: 4, previsao: "Entregue", cidade: "Maracanaú, CE", urgente: false,
    transportadora: "Jadlog", fotoColeta: "demo", fotoEntrega: "demo" },
];

// ─── Seed de tickets de suporte ──────────────────────────────────────
export const DEFAULT_TICKETS = [
  { id: 1, tipo: "cliente", assunto: "Dúvida sobre cadeira hidráulica V3",
    prioridade: "alta", status: "aberto", corretor: "Cawan Paiva",
    tempo: "2h atrás", cliente: "Studio Bella", categoria: "produto" },
  { id: 2, tipo: "corretor", assunto: "Preciso do catálogo de lavatórios",
    prioridade: "media", status: "em andamento", corretor: "Jessica Cavalcante",
    tempo: "4h atrás", cliente: "-", categoria: "material" },
  { id: 3, tipo: "cliente", assunto: "Prazo de entrega do pedido #4521",
    prioridade: "alta", status: "em andamento", corretor: "Raquel Nascimento",
    tempo: "1h atrás", cliente: "Espaço Glam", categoria: "logistica" },
  { id: 4, tipo: "cliente", assunto: "Troca de cor do espelho camarim",
    prioridade: "baixa", status: "resolvido", corretor: "Lu Vasconcelos",
    tempo: "1d atrás", cliente: "Beauty House", categoria: "produto" },
];
